import { useSyncTimezone } from 'src/components/TimezoneSync/hooks/useSyncTimezone';

const TimezoneSync = () => {
  useSyncTimezone();
  return null;
};

export default TimezoneSync;
